import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import axiosWithHandling from "../backend/axiosHanding.js";
import { apiURL } from "../backend/ApiURLs.js";
import { useSecureData } from "../backend/secureDataProvider.js";
import "../design/resetPassword.css"


function ValidateUrl() {
    const {inputKey} = useParams();

    const [userID, setUserID] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);    

    const url = `${apiURL}resetCredentials/validateResetPasswordToken?passwordTokenKey=${encodeURIComponent(inputKey)}`


    const navigate = useNavigate();
    const { setSecureData } = useSecureData();
    const handleNavigateToNextPageWithUserID = (data) => {
        setSecureData({userID : data});
        navigate(`/resetPasswordForm/${inputKey}`)
        
    }
    useEffect(() => {
        if (inputKey != null) {
            axiosWithHandling(url)
            .then(data => handleNavigateToNextPageWithUserID(Number(data.string)))
            .catch(error => {
                var statusCode = error.message

                setErrorMessage(validateResponseFromServer(statusCode));
            })
        }
    }, [inputKey]);

    return(
        <div className="resetPasswordBackground">
            <h2 className="validateUrlErrorMessage">{errorMessage}</h2>
        </div>
    );
}

const validateResponseFromServer = (statusCode) => {
    if (statusCode == 404) {
        return "Invalid URL, please request another reset password email"
    }

    if (statusCode == 403) {
        return "URL has expired, please request another reset password email"
    }

    if (statusCode == 406) {
        return "URL has already been used to reset password, please request another email"
    }

    return `Unkown error: ${statusCode}`
}

export default ValidateUrl;
